import DataTable from 'react-data-table-component';

import SelectCSTPIS from './SelectCSTPIS';
import SelectCFOP from './SelectCFOP';
import { useState, useMemo, useEffect  } from "react";
import axios from 'axios';
import * as XLSX from 'xlsx/xlsx.mjs';
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import useDeepSeekAPI from './useDeepSeekAPI'

import validar from '../files/validar.json'

export default function Tabela({ allData, setAllData, nomeEmpresa, dadosFiltrados, setDadosFiltrados}) {

  const apiKey = process.env.REACT_APP_DEEPSEEK_API_KEY;
  const apiUrl = process.env.REACT_APP_DEEPSEEK_API_URL;
  const analiseProdutos = [];
  for(let indice in allData){
    analiseProdutos.push(allData[indice].Produto)
  }
  console.log(allData)
  const [recomendacao, setRecomendacao] = useState(false);
  const [results, setResults] = useState(null);
  const [progress, setProgress] = useState(0);
  const [porcentagem, setPorcentagem] = useState(0);
  const { analyzeProducts, loading, error } = useDeepSeekAPI();
 
  const handleAnalyze = async () => {
    try {
      setProgress(0)
      const classification = await analyzeProducts(analiseProdutos, setProgress);
      // ADICIONA os campos da API SEM sobrescrever
      const enrichedData = allData.map((item, index) => {
        const apiClassification = classification.produtos[index];
        
        return {
          ...item, // Mantém TODOS os campos originais intactos
          // ADICIONA novos campos para análise:
          ncm_rec: (apiClassification?.ncm)?.replaceAll(".","") || "Não identificado",
          cst_rec: apiClassification?.cst || "  ",
          // Campos de metadados para análise:
          ncm_divergente: (() => {
            const ncmApi = apiClassification?.ncm;
            if (!ncmApi || ncmApi === "NI") return false;
            
            const ncmOrig = item.NCM.replace(/\./g, '').substring(0, 4);
            const ncmApiClean = ncmApi.replace(/\./g, '').substring(0, 4);
            
            return ncmOrig !== ncmApiClean;
          })(),
          cst_divergente: (() => {
            const cstApi = apiClassification?.cst;
            const cstOrig = item.CST_PIS;
            const ncmApi = apiClassification?.ncm;
            
            if (!cstApi) return false; // API não retornou nada
            if (!ncmApi || ncmApi === "NI") return false; // Se o NCM for NI ele não deverá ser classificado como divergente
            
            if (cstApi === "  ") {
              // API retornou em branco: divergente apenas se original for 04 ou 06
              return cstOrig === "04" || cstOrig === "06";
            } else {
              // API retornou valor específico: divergente se for diferente do original
              return cstApi !== cstOrig;
            }
          })(),
          data_classificacao: new Date().toISOString()
        };
      });
      setDadosFiltrados(enrichedData);
      console.log('Dados completos:', enrichedData);
      setRecomendacao(true)
    } catch (err) {
      console.log('Erro na análise:', err);
    }
  };

  // Monitora mudanças no progress
useEffect(() => {
  setPorcentagem(progress)
}, [progress]); // Executa sempre que progress mudar

  function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const conditionalRowStyles = [
  {
    when: row => (row.ncm_divergente || row.cst_divergente) && recomendacao,
    style: {
      color: 'red',
    },
  },
  // You can also pass a callback to style for additional customization
  {
    when: row => (!row.ncm_divergente && !row.cst_divergente && row.cst_rec !== "  "),
    style: {
      color: 'black',
    },
  },
];

const columns = [
  {
    name: 'Código Produto',
    selector: row => row.Cod_Produto,
    grow: 1,
    sortable: true,
    reorder: true,
  },
  {
      name: 'NCM',
    selector: row => row.NCM,
    grow: 1,
    sortable: true,
    reorder: true,
    conditionalCellStyles: [
			{
				when: row => row.ncm_divergente,
				style: {
					backgroundColor: 'rgba(251, 200, 227, 0.5)',
				},
			},
			{
				when: row => !row.ncm_divergente,
				style: {
					backgroundColor: 'rgba(255, 255, 255, 0.5)',
				},
			},
		],
  },
  {
      name: 'NCM Recomendado',
    selector: row => row.ncm_rec,
    grow: 2,
    sortable: true,
    reorder: true,
    omit: !recomendacao,
    conditionalCellStyles: [
			{
				when: row => row.ncm_divergente,
				style: {
					backgroundColor: 'rgba(251, 200, 227, 0.5)',
				},
			},
			{
				when: row => !row.ncm_divergente,
				style: {
					backgroundColor: 'rgba(255, 255, 255, 0.5)',
				},
			},
		],
  },
  {
      name: 'Produto',
      selector: row => row.Produto,
      grow: 2,
      sortable: true,
      reorder: true,
  },
  {
      name: 'Unidade',
      selector: row => row.UND,
      grow: 1,
      sortable: true,
      reorder: true,
  },
  {
      name: 'CFOP',
      selector: row => row.CFOP,
      grow: 1,
      sortable: true,
      reorder: true,
  },
/*  {
      name: 'Valor',
    selector: row => row.Valor_Produto,
    grow: 1,
    right: true,
    reorder: true,
  },*/
  {
      name: 'CST PIS',
      selector: row => row.CST_PIS,
    grow: 1,
    right: true,
      sortable: true,
      reorder: true,
    conditionalCellStyles: [
			{
				when: row => row.cst_divergente,
				style: {
					backgroundColor: 'rgba(251, 200, 227, 0.5)',
				},
			},
			{
				when: row => !row.cst_divergente,
				style: {
					backgroundColor: 'rgba(255, 255, 255, 0.5)',
				},
			},
		],
  },
/*  {
      name: 'PIS',
    selector: row => row.PIS,
    grow: 1,
    right: true,
    reorder: true,
  },*/
  {
      name: 'CST COFINS',
      selector: row => row.CST_COFINS,
      grow: 1,
      right: true,
      sortable: true,
      reorder: true,
    conditionalCellStyles: [
			{
				when: row => row.cst_divergente,
				style: {
					backgroundColor: 'rgba(251, 200, 227, 0.5)',
				},
			},
			{
				when: row => !row.cst_divergente,
				style: {
					backgroundColor: 'rgba(255, 255, 255, 0.5)',
				},
			},
		],
  },
  {
      name: 'CST COFINS Recomendado',
      selector: row => row.cst_rec,
      grow: 2,
      right: true,
      sortable: true,
      reorder: true,
      omit: !recomendacao,
    conditionalCellStyles: [
			{
				when: row => row.cst_divergente,
				style: {
					backgroundColor: 'rgba(251, 200, 227, 0.5)',
				},
			},
			{
				when: row => !row.cst_divergente,
				style: {
					backgroundColor: 'rgba(255, 255, 255, 0.5)',
				},
			},
		],
  },
/*  {
      name: 'COFINS',
    selector: row => row.COFINS,
    grow: 1,
    right: true,
    reorder: true,
  },*/
  ];
  
  const temCST = (item) => {
    if (selectedCSTPIS.length > 0) {
      for (var ind = 0; ind < selectedCSTPIS.length; ind++){
        if (item.CST_PIS === selectedCSTPIS[ind]) {
          return true
        }
      }
      return false
    } else {
      return true
    }
  }

  const temCFOP = (item) => {
    if (selectedCFOP.length > 0) {
      for (var ind = 0; ind < selectedCFOP.length; ind++){
        if (item.CFOP === selectedCFOP[ind]) {
          return true
        }
      }
      return false
    } else {
      return true
    }
  }

  const temNCM = (item) => {
    if (item.NCM.includes(selectedNCM)) {
      return true
    } else {
      return false
    }
  }

  const temProd = (item) => {
    if (item.Cod_Produto.includes(selectedCodProd)) {
      return true
    } else {
      return false
    }
  }

  const somarTotProd = (item) => {
    var temp = 0;
    item.map((nota) => temp = temp + parseFloat(nota.Valor_Produto))
    return temp
  }
  const rowsPerPageText = { rowsPerPageText: 'Linhas por Página:' }
  const [selectedCSTPIS, setSelectedCSTPIS] = useState([]);
  const [selectedCFOP, setSelectedCFOP] = useState([]);
  const [selectedNCM, setSelectedNCM] = useState("");
  const [selectedCodProd, setSelectedCodProd] = useState("");
  const [sumTotProd, setSumTotProd] = useState(somarTotProd(allData));
  const todosCST = [...new Set(allData.map(item => item.CST_PIS))];
  const SomatorioTodosCst = [{ id: 0, cst: "", soma: sumTotProd }]
  const [step, setStep] = useState(0);
  todosCST.sort();

  const SumTodosCST = () => {
    for (var ind = 0; ind < todosCST.length; ind++){
      const temp = allData.filter(
        item => (item.CST_PIS === todosCST[ind])
      ) 
      SomatorioTodosCst.push({id: (ind+1), cst: todosCST[ind], soma: somarTotProd(temp)})
    }
  }

  SumTodosCST()

  function handleFilter () {
    const temp = allData.filter(
      item => (temCFOP(item) && temCST(item) && temNCM(item) && temProd(item))
    ) 
    setDadosFiltrados(temp)
    setSumTotProd(somarTotProd(temp))
  }

  const handleDownload = () => {
    var wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dadosFiltrados);
    
    XLSX.utils.book_append_sheet(wb, ws, "CFe");

    XLSX.writeFile(wb, `Sped - ${nomeEmpresa}.xlsx`);
    
  }

  const actionsMemo = useMemo(() => <button className='downloadButton' onClick={handleDownload}><span>Exportar Excel</span></button>, [dadosFiltrados]);

  const next = () => {
    if (step < SomatorioTodosCst.length - 1) { 
      setStep(step + 1)
    } else {
      setStep(0)
    }
  }

  const prev = () => {
    if (step > 0) {
      setStep(step - 1)
    } else {
      setStep(SomatorioTodosCst.length - 1)
    }
  }

/*

          <Grid item xs={3}>
            <div className="somaAliquota">
              <ArrowBackIcon className='esquerda' onClick={prev} />
              <ArrowForwardIcon className='direita' onClick={next } />
              <div className="dadosSomatorio">
                <h2>Valor Total {step !== 0 && <><br/>{`do CST ${SomatorioTodosCst[step].cst}`}</>} </h2>
                <h2>{ Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(SomatorioTodosCst[step].soma)}</h2>
              </div>
            </div>
          </Grid>
          */

  return (
    <div className='paginaTabela'>
      <Box sx={{ flexGrow: 1 }}>
        {loading ? 
          <div className='overlayLoading'>
            <div className="UploadBox" >
              <div className="overlay-content">
                <h1>A análise do NCM dos produtos foi iniciada.</h1>
                <h2>Por favor, aguarde.</h2>
                <p>Este é um processo demorado, então pode levar um tempo. Por favor,  </p>
                <p>não feche a janela ou o progresso poderá ser perdido.</p>
                <p>Tempo total estimado: {`${parseInt((((allData.length/250)+1)*20)/60) + 2} min`}</p>
                <LinearProgressWithLabel value={porcentagem} />
              </div>
            </div>
          </div> : ``}
      <Grid container>
          <Grid item xs={12}>
            <div className='filtros'>
              <Grid >
                <Grid item xs={12}>
                  <div className="titulo">
                    Filtros da Tabela
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField id="codprod" label="Código do Produto" onChange={(e)=> setSelectedCodProd(e.target.value)}  fullWidth  variant="outlined" />
                </Grid>
                <Grid item xs={6}>
                    <TextField id="ncm" label="NCM" fullWidth onChange={(e)=> setSelectedNCM(e.target.value)} variant="outlined" />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                    <SelectCSTPIS allData={allData} setSelectedCSTPIS={setSelectedCSTPIS} />
                  </Grid>
                  <Grid item xs={6}>
                    <SelectCFOP allData={allData} setSelectedCFOP={ setSelectedCFOP} />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                <div className="dadoscentrais">
                  <button className='downloadButton' onClick={handleFilter}>Atualizar  Tabela</button>
                </div>
                  </Grid>
                  <Grid item xs={6}>
                <div className="dadoscentrais">
                  <button className='downloadButton' onClick={handleAnalyze}>Validar NCM</button>
                </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div className="tabela">
          <DataTable
        title={`Sped - ${nomeEmpresa}`}
          columns={columns}
        data={dadosFiltrados}
    conditionalRowStyles={conditionalRowStyles}
        dense
        pagination
        highlightOnHover
        striped
        pointerOnHover
        actions={actionsMemo}
        paginationRowsPerPageOptions={[10, 25, 50, 200, 500]}
          paginationComponentOptions={rowsPerPageText}
      />
        </div>
          </Grid>
      </Box>
      
      </div>
      );
}